(() => {
  'use strict';
  const scope = document.querySelector('[data-crc-product-handle]');
  if (!scope || !scope.querySelector('.crc-line-item-properties')) return;
  if (/pmag|magazine|firearm/i.test(scope.dataset.crcProductHandle)) return;

  const isPen = scope.dataset.crcProductHandle === 'metal-pens';
  const measured = ['metal-pens', 'personalized-two-glass-whiskey-decanter-set'].includes(scope.dataset.crcProductHandle);
  const qa = new URLSearchParams(location.search).get('crc_qa') === '1' || window.Shopify?.theme?.role !== 'main';
  const textField = () => scope.querySelector('[name="properties[Engraving Text]"]');
  const choice = () => {
    const selected = Array.from(scope.querySelectorAll('variant-picker .option-selector')).find(group => /customization|engraving/i.test(group.textContent))?.querySelector('input:checked, select');
    return selected?.value || 'Text / Name';
  };
  const textRequired = () => scope.querySelector('[data-crc-text-required]')?.dataset.crcTextRequired === 'true' && !(/logo|photo/i.test(choice()) && !/text/i.test(choice()));
  const metadata = () => ({
    schema_version: 1,
    product_id: scope.dataset.crcProductId,
    product_handle: scope.dataset.crcProductHandle,
    variant_id: scope.querySelector('.js-product-form [name="id"]')?.value || '',
    customization: isPen ? choice() : 'layout',
    text_present: Boolean(textField()?.value.trim()),
    notes_present: Boolean(scope.querySelector('[name="properties[Design Notes]"]')?.value.trim()),
    proof_requested: /please/i.test(scope.querySelector('[name="properties[Proof Requested]"]')?.value || ''),
    internal_test: qa
  });

  // Only allowlisted state is published. Never send field values, artwork URLs,
  // form data, buyer details, raw error messages, or full page URLs.
  function track(name, extra = {}) {
    if (!measured) return;
    const payload = {...metadata(), ...extra};
    const entry = {name, payload, status: 'consent_blocked'};
    if (qa) {
      window.CRCMeasurementLog ||= [];
      window.CRCMeasurementLog.push(entry);
    }
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (!window.Shopify?.analytics?.publish) {
      entry.status = 'publisher_unavailable';
      return;
    }
    try {
      entry.status = 'dispatched';
      Promise.resolve(window.Shopify.analytics.publish(name, payload)).then(() => {
        entry.status = 'publish_resolved';
      }).catch(() => { entry.status = 'publish_failed'; });
    } catch (_) { entry.status = 'publish_failed'; }
  }

  function sync() {
    const field = textField();
    if (!field) return;
    const required = textRequired();
    field.required = required;
    field.setAttribute('aria-required', String(required));
    scope.querySelector('[data-crc-required-indicator]')?.toggleAttribute('hidden', !required);
    field.setCustomValidity(required && !field.value.trim() ? 'Enter the exact engraving text for this option.' : '');
  }

  let started = false;
  const begin = () => {
    if (!started) { track('crc:personalization_started'); started = true; }
  };
  scope.addEventListener('input', event => {
    if (!event.target.name?.startsWith('properties[')) return;
    sync();
    begin();
  });
  scope.addEventListener('change', event => {
    sync();
    if (event.target.matches('input[type="radio"], [name="properties[Proof Requested]"]')) begin();
  });
  document.addEventListener('on:variant:change', sync);
  scope.addEventListener('invalid', event => {
    if (event.target === textField()) track('crc:validation_error', {error_code:'engraving_text_required'});
  }, true);
  scope.addEventListener('click', event => {
    if (event.target.closest('[data-crc-quote-link]')) track('crc:quote_clicked');
    if (!event.target.closest('.ph_clone_atc_btn, [data-ph-cart-clone="true"]')) return;
    sync();
    if (textRequired() && !textField()?.value.trim()) {
      event.preventDefault(); event.stopImmediatePropagation();
      textField()?.reportValidity();
      return;
    }
    if (window.CRCUploadlyVariantSync && !window.CRCUploadlyVariantSync.validateRequiredUpload()) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!scope.contains(event.target) || !event.target.matches('.js-product-form')) return;
    sync();
    if (textRequired() && !textField()?.value.trim()) {
      event.preventDefault(); event.stopImmediatePropagation();
      textField()?.reportValidity();
      return;
    }
    // The existing pack guard re-submits after its asynchronous cart check.
    // Only record the final submission, after that guard has passed.
    if (event.target.closest('product-form[data-crc-pack-product]') && event.target.dataset.crcPackChecked !== 'true') return;
    if (event.target.querySelector('[name="add"]')?.getAttribute('aria-disabled') === 'true') return;
    if (qa && !event.target.querySelector('[name="properties[_CRC QA]"]')) {
      const marker = document.createElement('input');
      marker.type = 'hidden'; marker.name = 'properties[_CRC QA]'; marker.value = 'shopping-path-review-2026-10-11';
      event.target.append(marker);
    }
    track('crc:personalization_ready');
  }, true);
  const ownsCartEvent = event => event.target === scope.querySelector('.js-product-form')?.closest('product-form');
  document.addEventListener('on:cart:add', event => {
    if (!ownsCartEvent(event) || event.detail?.variantId == null) return;
    track('crc:personalized_cart_added', {variant_id: String(event.detail.variantId)});
  });
  document.addEventListener('on:cart:error', event => {
    if (!ownsCartEvent(event)) return;
    track('crc:validation_error', {error_code:'cart_rejected'});
  });
  const observer = new MutationObserver(() => {
    if (scope.querySelector('[data-crc-upload-error]:not([hidden])')) {
      if (!observer.uploadErrorSeen) track('crc:validation_error', {error_code:'artwork_required'});
      observer.uploadErrorSeen = true;
    } else observer.uploadErrorSeen = false;
  });
  observer.observe(scope, {subtree:true, childList:true, attributes:true, attributeFilter:['hidden']});
  sync();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], () => {});
  }
})();
